import { Heading } from '@chakra-ui/layout';
import React from 'react';
import classes from './styles.module.scss';
import { ReactComponent as OfferRewardIcon } from '../../../../assets/icons/offer.svg';
import { ReactComponent as DollarIcon } from '../../../../assets/icons/dollar.svg';
import { ReactComponent as ReferralIcon } from '../../../../assets/icons/referral.svg';
import { ReactComponent as GooglePlayGameIcon } from '../../../../assets/icons/games.svg';
import { ReactComponent as OfferRewardProIcon } from '../../../../assets/icons/offer.svg';
import { ReactComponent as DollarProIcon } from '../../../../assets/icons/dollar.svg';
import { ReactComponent as ReferralProIcon } from '../../../../assets/icons/referral.svg';
import { ReactComponent as GooglePlayGameProIcon } from '../../../../assets/icons/games.svg';
import { ReactComponent as LootProIcon } from '../../../../assets/icons/loot.svg';
import { ReactComponent as StatsProIcon } from '../../../../assets/icons/leaderboard.svg';
import { ReactComponent as Logo } from '../../../../assets/logo.svg';
import { ReactComponent as ProLogo } from '../../../../assets/logo/pro-logo.svg';
import { useNavigate } from 'react-router-dom';

import clsx from 'clsx';
import { PLAY_STORE_URL } from '../../../../config';
import SKButton from '../../../../components/UI/SKButton';
import { DOWNLOAD_PAGE } from '../../../../constants/route.const';
const PLANS = {
  ChillarPro: {
    title: 'Chillar Pro',
    submitButtonText: 'Download Chillar Pro Now',
    submitButtonLink: process.env.REACT_APP_SIKKA_APK_DOWNLOAD_URL,
    features: [
      {
        title: 'Higher Offer Prices!',
        subtitle: '24Hrs response time',
        icon: OfferRewardProIcon,
      },
      {
        title: 'Higher Payouts',
        subtitle: 'More is more! Transfer more to your bank account',
        icon: DollarProIcon,
      },
      {
        title: 'Higher Referral Limits',
        subtitle: "Gain extra Chillar's by referring unlimited people.",
        icon: ReferralProIcon,
      },
      {
        title: 'Play Unlimited Games and Earn',
        subtitle: 'Spin the wheel and earn more Chillar ',
        icon: GooglePlayGameProIcon,
      },
      {
        title: 'Monthly Loot',
        subtitle: 'Now get new offers quite often than ever!',
        icon: LootProIcon,
      },
      {
        title: 'Leaderboard',
        subtitle: '24Hrs Response Time',
        icon: StatsProIcon,
      },
    ],
  },
  Chillar: {
    title: 'Chillar',
    submitButtonText: 'Download Chillar Now',
    submitButtonLink: PLAY_STORE_URL,
    features: [
      {
        title: 'Offer Prices',
        subtitle: 'Complete Offers and win Chillar',
        icon: OfferRewardIcon,
      },
      {
        title: 'Higher Payouts',
        subtitle: 'Complete Offers with higher payout',
        icon: DollarIcon,
      },
      {
        title: 'Unlimited Referrals',
        subtitle: 'Refer and earn more reward',
        icon: ReferralIcon,
      },
      {
        title: 'Play Games and Earn',
        subtitle: 'Spin the wheel and earn Chillar',
        icon: GooglePlayGameIcon,
      },
    ],
  },
};
export default function OurPlans(props) {
  return (
    <div className={classes.OurPlans}>
      <Heading as="h2">Unlimited earnings with Our Pro Version</Heading>
      <div className={classes.plans}>
        <PlanCard data={PLANS.ChillarPro} pro={true} />
        <PlanCard data={PLANS.Chillar} />
      </div>
    </div>
  );
}

function PlanCard(props) {
  let navigate = useNavigate();
  return (
    <div className={clsx(classes.PlanCard, props.pro && classes.ProCard)}>
      {props.pro && <div className={classes.ProCardImage}></div>}
      <div className={classes.logo}>
        {props.pro ? <ProLogo /> : <Logo />}
        <div className={classes.title}>{props.data.title}</div>
      </div>
      <div className={classes.rows}>
        {props.data.features.map(d => (
          <div className={classes.row} key={d.title}>
            <d.icon />
            <div className={classes.content}>
              <div className={classes.title}> {d.title}</div>
              <div className={classes.subtitle}> {d.subtitle}</div>
            </div>
          </div>
        ))}
      </div>
      <div className={classes.action}>
        <SKButton
          onClick={() => {
            if (props.pro) {
              window.gtag &&
                window.gtag('event', 'Chillarpro_download', {
                  from: 'OUR_PLAN',
                });
            }
            props.pro
              ? navigate(DOWNLOAD_PAGE)
              : window.open(props.data.submitButtonLink);
          }}
        >
          {props.data.submitButtonText}
        </SKButton>
      </div>
    </div>
  );
}
